import React, { useEffect } from "react";
import { useCallback } from "react";
import { useHistory } from "react-router";
import ReactDOM from "react-dom";
import { FiFolder } from "react-icons/fi";

import useLoading from "../../../hooks/useLoading";

import api from "../../../service/api";

import DataTables from "../../../modules/DataTables";
import { Error as notificationError } from "../../../modules/Notifications";

function useReleases() {
    const history = useHistory();

    const { loading } = useLoading();

    const setReactComponentinTable = useCallback(() => {
        const handleEdit = (id) => {
            history.push(`/ctop/lancamento/${id}`);
        };

        const setReactComponentinTable = () => {
            const editarEls = document.querySelectorAll(".editar");

            for (const editarEl of editarEls) {
                ReactDOM.render(
                    <FiFolder
                        className="cursor-pointer"
                        onClick={() => {
                            handleEdit(editarEl.dataset.id);
                        }}
                    />,
                    document.getElementById(editarEl.id)
                );
            }
        };

        setReactComponentinTable();
    }, [history]);

    useEffect(() => {
        const show = async () => {
            const idLoading = loading();

            try {
                const response = await api.get("/lancamentos?_limit=-1");

                const serializedData = response.data.map((item) => {
                    const { id, nome } = item;

                    return {
                        nome,
                        Abrir: `<div class="editar" data-id="${id}" id="editar-${id}"></div>`,
                    };
                });

                DataTables(
                    "#releases-table",
                    serializedData,
                    [
                        { title: "Nome", data: "nome" },
                        { title: "Abrir", data: "Abrir" },
                    ],
                    () => {
                        setReactComponentinTable();
                    }
                );

                loading(idLoading);
            } catch (error) {
                notificationError(error);

                loading(idLoading);
            }
        };

        show();
    }, [loading, setReactComponentinTable]);

    return {};
}

export default useReleases;
